<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="activesessions.data"
      :options.sync="options"
      :server-items-length="activesessions.total"
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions: [10, 50, 100],
      }"
      :loading="isLoading"
      no-data-text="Pas de session active sur ce portail."
      @click:row="
        (item) =>
          $router.push({
            name: 'cartes-details',
            params: { id: item.card.id },
          })
      "
    >
      <template v-slot:item.sessionStartsAt="{ item }">
        {{ getInternationalDate(item.sessionStartsAt) }}
      </template>

      <template v-slot:item.lastUpdatedAt="{ item }">
        {{ getInternationalDate(item.lastUpdatedAt) }}
      </template>

      <template v-slot:item.volumUp="{ item }">
        {{ formatBytes(item.volumUp) + " / " + formatBytes(item.volumDown) }}
      </template>

      <template v-slot:item.debitDownloadBps="{ item }">
        {{
          formatBytes(item.debitUploadBps) +
          " / " +
          formatBytes(item.debitDownloadBps)
        }}
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { date } from "@/composables/date";
import { watch, toRefs, onMounted } from "@vue/composition-api";
import { useActiveSession } from "../../composables/activesession";

export default {
  props: {
    isPortalClient: Boolean,
    isCard: Boolean,
    id: [Number, String],
    loading: Boolean,
  },
  setup(props, { emit }) {
    const { getInternationalDate } = date();
    const {
      activesessions,
      data,
      listClientActiveSessions,
      listCardActiveSessions,
    } = useActiveSession();

    onMounted(async () => {
      emit("update:loading", true);
      if (props.isPortalClient) {
        await listClientActiveSessions(props.id);
      } else if (props.isCard) {
        await listCardActiveSessions(props.id);
      }
      emit("update:loading", false);
    });

    function formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }

    watch(
      [() => data.options],
      (newValues, oldValues) => {
        if (oldValues[0].page !== undefined) {
          emit("update:loading", true);
          if (props.isPortalClient) {
            listClientActiveSessions(props.id);
          } else if (props.isCard) {
            listCardActiveSessions(props.id);
          }
          emit("update:loading", false);
        }
      },
      {
        deep: true,
      }
    );
    watch(
      () => activesessions.value.total,
      (newValue) => {
        emit("update:total-sessions", newValue);
      }
    );

    return {
      ...toRefs(data),
      activesessions,
      getInternationalDate,
      formatBytes,
      headers: [
        { text: "Carte", value: "card.id" },
        { text: "Nas", value: "nas" },
        { text: "Début", value: "sessionStartsAt" },
        { text: "Dernière MAJ à", value: "lastUpdatedAt" },
        { text: "Authentification", value: "authentification" },
        {
          text: "Volume up/down",
          value: "volumUp",
          sortable: false,
        }, // volum_up && volum_down
        {
          text: "Débit up/down",
          value: "debitDownloadBps",
          sortable: false,
        }, // debit_upload_bps && debit_download_bps
        { text: "Ip", value: "ip" },
        { text: "MAC", value: "mac" },
        { text: "Ouverture Server", value: "openingServer", sortable: false },
      ],
    };
  },
};
</script>
